import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 bg-brand-graphite text-center text-brand-cream/60 text-xs" data-id="element-74">
      <div className="max-w-3xl mx-auto space-y-3" data-id="element-75">
        <p className="leading-snug max-w-2xl mx-auto font-medium" data-id="element-76">
          © 2026 Nutritionist Pro™ — All Rights Reserved. The information
          provided on this website is intended for educational purposes only and
          is designed as a professional resource for Nutritionists and
          Dietitians. It is not intended to replace professional clinical
          judgment or individualized nutritional assessment. Always use your
          professional expertise when developing nutrition recommendations for
          your clients.
        </p>
        <div className="flex justify-center gap-3 font-bold tracking-wide uppercase" data-id="element-77">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-78">
            Terms &amp; Conditions
          </a>
          <span data-id="element-79">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-80">
            Privacy Policy
          </a>
          <span data-id="element-81">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-82">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}